import mountReactApp from 'mount-react-app';
import {routes, reducers} from 'mbus-seo';
//import './index.css';
function renderApp() {
  mountReactApp({routes, reducers});
}

renderApp();

